module.exports = __webpack_public_path__ + "img/胡勇.7d612ee6.jpg";